<template>
    <v-container fluid class="px-0 mx-0">
        <match-bar :matches="matches" class="mb-15" />
        <!-- Sponsors marquee -->
        <v-card class="text-left white--text mb-1 rounded-0" color="teal">
            <v-card-title style="font-size: 40px; padding-left: 10px; margin: 0;">SPONSORS & PARTNERS</v-card-title>
        </v-card>
        <marquee :speed="50" :height="120" :images="sponsors" />
        <v-card class="text-left white--text mt-16 rounded-0" color="#232323">
            <v-card-title style="font-size: 40px; padding-left: 10px; margin: 0;">STANDINGS</v-card-title>
        </v-card>
        <v-row class="mb-16 px-1">
            <v-col v-for="leagueGroup in leagueGroups" :key="`LeagueGroup-${leagueGroup.id}`" cols="12" md="6">
                <div class="text-left" style="font-size: 35px; color: #232323; padding-left: 0; margin: 0;">
                    {{ leagueGroup.title + ' League' }}
                </div>
                <home-standings :league-group="leagueGroup" :leagues="leagues" />
            </v-col>
        </v-row>
        <!-- Teams marquee -->
        <v-card class="text-left white--text mb-1 rounded-0" color="teal">
            <v-card-title style="font-size: 40px; padding-left: 10px; margin: 0;">TEAMS</v-card-title>
        </v-card>
        <marquee v-if="teams" :speed="250" :height="150" :images="teams" />
        <!-- <v-card class="text-left white--text mb-1 mt-16 rounded-0" color="teal">
            <v-card-title style="font-size: 40px; padding-left: 10px; margin: 0;">VIDEOS</v-card-title>
        </v-card>
        <v-row class="mx-0 px-0 my-0 py-0">
            <v-col cols="12" class="mx-0 px-0" style="display: inline-flex; overflow-x: auto;">
                <v-card
                    v-for="video in videos"
                    :key="video.id.videoId"
                    style="background: #232323; border-right: 1px solid teal;"
                    :style="$vuetify.breakpoint.mobile ? 'min-width: 300px;' : 'min-width: 550px;'"
                    class="mx-1 py-2 px-2 rounded-0"
                    dark
                >
                    <div @click="playVideo(video.id.videoId)" style="cursor: pointer; position: relative;">
                        <v-img
                            v-if="!video.isPlaying"
                            :src="video.snippet.thumbnails.maxres?.url || video.snippet.thumbnails.high.url || `https://img.youtube.com/vi/${video.id.videoId}/maxresdefault.jpg`"
                            :aspect-ratio="$vuetify.breakpoint.mobile ? 16/9 : 16/9"
                            class="mb-2"
                        >
                            <v-icon
                                color="white"
                                size="64"
                                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                            >
                                mdi-play-circle
                            </v-icon>
                        </v-img>
                        <iframe
                            v-else
                            :width="$vuetify.breakpoint.mobile ? '280px' : '500px'"
                            :height="$vuetify.breakpoint.mobile ? 'auto' : '300px'"
                            :src="`https://www.youtube.com/embed/${video.id.videoId}?autoplay=1`"
                            frameborder="0"
                            allowfullscreen
                        />
                        <div>{{ decodeHTML(video.snippet.title) }}</div>
                    </div>
                </v-card>
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
    import Marquee from '@/components/Marquee.vue'
    import teamService from '@/services/team'
    import HomeStandings from '@/components/HomeStandings.vue'
    import MatchBar from '@/components/MatchBar.vue'
    import matchService from '@/services/match'

    export default {
        name: 'Home',
        components: {
            Marquee,
            HomeStandings,
            MatchBar
        },
        data() {
            return {
                sponsors: [
                    require('@/assets/sportsiq.jpg'),
                    require('@/assets/gsa.jpg'),
                    require('@/assets/molten.png'),
                    require('@/assets/e-academy.png')
                ],
                teams: null,
                assetsUrl: 'https://storage.googleapis.com',
                matches: [],
                videos: []
                // VUE_APP_YT_API_KEY: process.env.VUE_APP_YT_API_KEY,
                // VUE_APP_YT_CHANNEL_ID: process.env.VUE_APP_YT_CHANNEL_ID
            }
        },
        computed: {
            leagueGroups() {
                return this.$store.getters.getLeagueGroups
            },
            leagues() {
                return this.$store.getters.getLeagues
            }
        },
        // mounted() {
        //     this.fetchLiveStreams()
        // },
        created() {
            this.fetchTeams()
            this.initializeHome()
        },
        methods: {
            async initializeHome() {
                await Promise.all([
                    this.$store.dispatch('ensureLeagueGroups'),
                    this.$store.dispatch('ensureLeagues'),
                    this.getMatches()
                ])
            },
            playVideo(videoId) {
                // Set the isPlaying flag on the clicked video
                this.videos = this.videos.map(v => ({
                    ...v,
                    isPlaying: v.id.videoId === videoId ? true : v.isPlaying || false
                }))
            },
            decodeHTML(html) {
                const txt = document.createElement('textarea')
                txt.innerHTML = html
                return txt.value
            },
            // async fetchLiveStreams() {
            //     const res = await fetch(
            //         `https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=completed&type=video&order=date&maxResults=10&channelId=${this.VUE_APP_YT_CHANNEL_ID}&key=${this.VUE_APP_YT_API_KEY}`
            //     )
            //     const data = await res.json()
            //     this.videos = data.items
            // },
            getMatches() {
                return matchService.getMatches(1, 50, { query: '{"NotOr": [ {"scoreTeam1": 0, "scoreTeam2": 20}, {"scoreTeam1": 20, "scoreTeam2": 0} ]}' }).then(resp => {
                    this.matches = resp.data.content
                })
            },
            fetchTeams() {
                teamService.getTeams().then(resp => {
                    this.teams = resp.data.content.map(team => {
                        return team.logo ? `${this.assetsUrl}/${team.logo}` : require('@/assets/main_logo.png')
                    })
                })
            }
        }
    }
</script>
